import { useMutation, useQueryClient } from "@tanstack/react-query";
import { vehiclesService } from "../services";
import type { CreateExpedientRequest } from "../types";
import { VEHICLE_EXPEDIENT_QUERY_KEY } from "./get-expedient.query";

export const useCreateOrUpdateExpedient = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: CreateExpedientRequest) =>
			vehiclesService.createOrUpdateExpedient(data),
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({
				queryKey: [VEHICLE_EXPEDIENT_QUERY_KEY, String(variables.vehicleId)],
			});
		},
	});
};
